<div class="fixed inset-0 z-50 flex items-center justify-center">
  <div class="absolute inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-sm cursor-pointer"
    (click)="_dialogRef.close()">
  </div>

  <div class="relative z-10 max-w-[1100px] w-full mx-6">
    <div class="bg-white text-slate-900 dark:bg-surface-1 dark:text-slate-200 rounded-2xl shadow-2xl overflow-hidden">

      <!-- Header -->
      <div class="flex items-center justify-between p-6 border-b border-slate-200 dark:border-slate-800">
        <div>
          <h3 class="text-2xl font-semibold">{{ hasMultipleTabs ? 'Comprehensive Summary' : activeTab.module }}</h3>
        </div>
        <div class="flex items-center gap-3">
          <button class="p-2 rounded-full cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800"
            (click)="_dialogRef.close()" aria-label="Close modal">
            <app-icon name="x" class="text-slate-700 dark:text-slate-300" />
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="flex gap-0">

        <!-- Sidebar with tabs (only shown when multiple tabs exist) -->
        @if (hasMultipleTabs) {
        <div class="w-64 border-r border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/30 p-4">
          <nav class="space-y-1">
            <button *ngFor="let tab of data; let i = index" (click)="selectTab(i)"
              class="w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer"
              [ngClass]="{
                'bg-indigo-600 text-white shadow-md': activeTabIndex === i,
                'text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-700/50': activeTabIndex !== i
              }">
              {{ tab.module }}
            </button>
          </nav>
        </div>
        }

        <!-- Main content area -->
        <div class="flex-1 p-6">
          <!-- Main content area -->
          <div class="flex-1 p-6">
            @if (hasMultipleTabs) {
            <div class="mb-3">
              <h4 class="text-xl font-semibold">{{ activeTab.module }}</h4>
            </div>
            }
            <div
              class="max-h-[70vh] overflow-y-scroll pr-2 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              @if (summary) {
              <section class="mb-5">
                <h4 class="font-bold text-sm text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-2">Summary
                </h4>
                <div class="text-sm">
                  <p class="leading-relaxed">{{ summary }}</p>
                </div>
              </section>
              }


              <!-- Insights -->
              @if (insights) {
              <section class="mb-5">
                <h4 class="font-bold text-sm text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-3">Insights
                </h4>
                <div class="space-y-4">
                  <div *ngFor="let insight of insights"
                    class="border border-slate-200 dark:border-slate-800 rounded-lg p-4 bg-slate-50 dark:bg-slate-800/60">
                    <div class="flex items-start justify-between">
                      <div>
                        <h5 class="font-semibold text-slate-500 dark:text-slate-400">{{ insight.label }}</h5>
                        <p class="text-sm font-semibold text-slate-400 dark:text-slate-200 mt-2">{{ insight.evidence }}
                        </p>
                        <p class="text-sm text-slate-600 dark:text-slate-400 mt-1">{{ insight.value }}</p>
                        <span class="inline-block px-2 py-1 text-xs font-semibold rounded-md mt-3"
                          [ngClass]="severityClasses[insight.severity]">
                          {{ insight.severity.toUpperCase() }} PRIORITY
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
              </section>
              }


              <!-- Playbook -->
              @if (playbook) {
              <section class="mb-5">
                <h4 class="font-bold text-sm text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-3">Action
                  Playbook</h4>
                <div class="space-y-3 pl-4">
                  <div *ngFor="let action of playbook">
                    <h5 class="font-semibold text-sm">{{ action.step }}</h5>
                    <p class="text-xs text-slate-600 dark:text-slate-400 mt-1">
                      👤 {{ action.owner }} • <span class="dark:text-slate-200">⏱</span> {{ action.timeframe }} • 📊 {{
                      action.expected_change }} • 💪 {{ action.effort }} effort
                    </p>
                  </div>
                </div>
              </section>
              }


              <!-- Recommendations -->
              @if (actions) {
              <section class="mb-5">
                <h4 class="font-bold text-sm text-slate-500 dark:text-slate-400 uppercase tracking-wide mb-3">
                  Recommended Actions
                </h4>
                <ul class="list-none pl-5 text-sm space-y-2">
                  <li *ngFor="let action of actions">{{ action }}</li>
                </ul>
              </section>
              }


              <!-- Anomalies Detected -->
              @if (anomalies) {
              <section class="mb-5">
                <div
                  class="p-4 border-l-4 border-amber-400 dark:border-amber-500 bg-amber-50 dark:bg-slate-500/50 rounded-r-md">
                  <h5 class="text-sm font-semibold text-amber-700 dark:text-amber-300">Anomalies Detected</h5>
                  <div class="text-sm text-amber-700 dark:text-amber-200 mt-2">
                    <p *ngFor="let anomalie of anomalies">{{ anomalie }}</p>
                  </div>
                </div>
              </section>
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>